
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
  }
})
export default class TaskTemplateCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly creatorId: number
  @Prop({ required: true })readonly title: string
  @Prop({ required: true })readonly description: string
  @Prop({ required: true })readonly keywords: string
  @Prop({ required: true })readonly type: string
  @Prop({ required: true })readonly category: string
  @Prop({ required: true })readonly prompt: string
  @Prop({ required: true })readonly scorePrompt: string
  @Prop({ required: true })readonly sampleQuote: string
  @Prop({ required: true })readonly sampleOutput: string
  @Prop({ required: true })readonly active: boolean
  @Prop({ required: true })readonly hasViewBtn: boolean
  @Prop({ required: true })readonly selectedUserId: string

  data () {
    return {
      isLoading: false
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  viewTaskTemplate () {
    this.$emit('viewClick', this.id)
  }

  createTask () {
    this.$buefy.dialog.confirm({
      title: 'Create Task',
      message: 'Are you sure about creating a task?',
      onConfirm: this.createPsycheTask,
      canCancel: true
    })
  }

  async createPsycheTask () {
    try {
      this.isLoading = true

      var resp = await FetchWrapper.get(`${process.env.VUE_APP_SERVERURL}/createPsycheTask/${this.selectedUserId}`)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Task created Successfully. Do you wanna go to task page?',
          onConfirm: () => {
            window.location.href = `/home/task/${resp.id}`
          },
          canCancel: true
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
